const { __ } = wp.i18n;
const { Flex, FlexItem, FlexBlock, TextControl, Button } = wp.components;
const { useState, useRef } = wp.element;

const Chapter = ({ chapter, key, onChange, onAdd, addNew = false, onRemove }) => {
  const { time, name } = chapter;
  const minusWrapper = useRef(null);

  return (
    <Flex>
      <FlexItem>
        <TextControl style={{ width: "55px" }} value={time} placeholder="00:00" onChange={(val) => onChange({ ...chapter, time: val })} />
      </FlexItem>
      <FlexItem>
        <TextControl style={{ marginLeft: "10px" }} value={name} placeholder="Name" onChange={(val) => onChange({ ...chapter, name: val })} />
      </FlexItem>
      <FlexItem>
        {addNew ? (
          <Button icon="plus-alt" style={{ marginBottom: "10px" }} onClick={onAdd} />
        ) : (
          <div
            ref={minusWrapper}
            style={{ opacity: "0" }}
            onMouseEnter={() => (minusWrapper.current.style.opacity = 1)}
            onMouseLeave={() => (minusWrapper.current.style.opacity = 0)}
          >
            <Button icon="minus" style={{ marginBottom: "10px" }} onClick={onRemove} />
          </div>
        )}
      </FlexItem>
    </Flex>
  );
};

export default Chapter;
